import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { APP_CONSTANTS, MENU_CONSTANTS } from '../../constants/app-constants';
import { isRcnSurveyApplication } from 'src/app/shared/lib/custom-tools';
import { ClientUsersService } from 'src/app/client-users/client-users.service';
import { environment } from 'src/environments/environment';
import { role } from '../../constants/role-enum';
import { SessionService } from '../../session-service/session.service';
import { BaseResponse } from 'src/app/shared/models/base-response.model';
import { TopNavigationService } from '../top-navbar/top-nav.service';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { UserDetails } from 'src/app/core/models/user-details.model';
import { ImpersonationService } from '../../impersonation/impersonation.service';
import { Subject, combineLatest, takeUntil } from 'rxjs';
import { ToastrService, LoadingIndicatorService } from '@kpmg-tax/ui';
import { FileService } from 'src/app/shared/file-service/file.service';
import { HomeService } from 'src/app/home/home.service';
import { SESSION_CONST } from '../../constants/session-constants';
import { EngagementInsigtsService } from 'src/app/engagement-insights/engagement-insights.service';

@Component({
    selector: 'top-navbar-right',
    templateUrl: './top-navbar-right.component.html',
    styleUrls: ['./top-navbar-right.component.scss']
})

export class TopNavBarRightComponent implements OnInit {
    isClientManager = false;
    emailstrings = '';
    studySetupEmailStrings = '';
    roleId: number;
    isSupportMenuClicked = false;
    isInfoMenuClicked = false;
    isAdminMenuClicked = false;
    isProfileMenuClicked = false;
    user: UserDetails;
    isRcnSurveyApp: boolean = false;
    hasAdminAccess = false;
    isClientAdmin = false;
    manageClientText = '';
    isChampion = false;
    isSignInDone = false;
    engagementTeamEmails: BaseResponse;
    studySetupHelpText = APP_CONSTANTS.STUDY_SETUP_HELP_TEXT;
    technicalSupportHelpText = APP_CONSTANTS.TECHNICAL_SUPPORT_HELP_TEXT;
    private _destroyed$ = new Subject<void>();
    constructor(
        private _router: Router,
        public topNavigationService: TopNavigationService,
        public sessionService: SessionService,
        private _userDataService: UserDataService,
        private _clientUsersService: ClientUsersService,
        private impersonationService: ImpersonationService,
        private _homeService: HomeService,
        public toastrService: ToastrService,
        private _loader: LoadingIndicatorService,
        private _fileService: FileService,
        private _engagementService: EngagementInsigtsService,
    ) { }

    ngOnInit() {
        this._router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.closeSubmenu();
            }
        });

        combineLatest([
            this._userDataService.userDetails$,
            this.impersonationService.smeUserDetails$,
            this.impersonationService.clientManagerModeActive$,
            this._clientUsersService.GetEngagementTeamEmails()
        ]).subscribe(([userDetails, smeUserDetails, managerModeActive, engTeamEmails]) => {
            this.user = userDetails;
            this.roleId = userDetails.roleId;
            if (this.roleId > 0) { this.isSignInDone = true; }
            this.isClientManager = (this.user.roleId === role.clientManager);
            this.isChampion = (this.user.roleId === role.champion);
            this.hasAdminAccess = (this.user.roleId === role.admin) || (this.user.roleId === role.champion);
            this.isClientAdmin = this.user.roleId === role.clientAdmin;
            this.manageClientText = this.isClientAdmin ? APP_CONSTANTS.MANAGE_USERS : APP_CONSTANTS.MANAGE_CLIENT_USERS;
            this.engagementTeamEmails = engTeamEmails as BaseResponse;
            const isSwitchedSmeOrClientManagerRole = !!smeUserDetails || managerModeActive;
            if ((this.roleId === role.clientManager || this.roleId === role.respondent || this.roleId === role.clientAdmin) && !isSwitchedSmeOrClientManagerRole) {
                const usersEmail = this.engagementTeamEmails?.result?.supportMailUsers?.toString();
                this.emailstrings = usersEmail ? usersEmail : 'mailto:' + environment.supportEmail + '?cc=;';
            } else {
                this.emailstrings = 'mailto:' + environment.supportEmail + '?cc=;';
            }
            this.emailstrings = this.emailstrings + '&subject=Research Credit Navigator Support';
            this.studySetupEmailStrings = 'mailto:' + environment.studyOnboardingHelpEmail + '?cc=' + environment.supportEmail + '&subject=Research Credit Navigator Study Onboarding Help';
        });
        this.isRcnSurveyApp = isRcnSurveyApplication();
    }

    openHelpInfo(): void {
        window.open('assets/RCN_User_Guide.pdf', '_blank').focus();
    }

    openMFAguideInfo() {
        window.open('assets/MFA_Setup.pdf', '_blank').focus();
    }

    openSupportMail() {
        window.open('mailto:' + environment.supportEmail + '?cc=; &subject=Research Credit Navigator Support', '_self').focus();
    }

    openServiceNowSupport() {
        window.open(environment.serviceNowUrl, '_blank').focus();
    }
    
    openSupportMailSignInDone(){
        let engagementId = Number(this.sessionService.getSession(SESSION_CONST.ENGAGEMENTID));        
        if(engagementId > 0){
            this._engagementService
            .getEngagementById(engagementId, false)
            .pipe(takeUntil(this._destroyed$))
            .subscribe(data => {
            let engagementNumber = data.result.engagementNumber;
            let engagementName = data.result.engagementName;
            let clientName = this.sessionService.getSession(SESSION_CONST.CLIENTNAME);                    
            this.emailstrings = `${this.emailstrings} &subject=Research Credit Navigator Support [${engagementId}] ${engagementName} (${clientName})`;    
            window.open(this.emailstrings, '_self').focus();
            });            
        }
        else{
            this.openSupportMail();
        }                                        
    }

    downloadReleaseHistory() {
        this._loader.display(true, true);
        this._homeService.GetReleaseHistoryDownload().subscribe(
            blob => {
                const fileName = "RCN Release History";
                const extention = '.pdf';
                this._fileService.saveBlobToFile(blob, `${fileName}${extention}`);
                this._loader.display(false);
            },
            error => {
                this._loader.display(false);             
                return;
            }
        );
    }

    loadSubMenu(event: PointerEvent): void {
        const targetElement = event.currentTarget as HTMLElement;
        if (targetElement && targetElement.title) {
            switch (targetElement.title.toLowerCase().trim()) {
                case MENU_CONSTANTS.SUPPORT:
                    this.isSupportMenuClicked = !this.isSupportMenuClicked;
                    this.isInfoMenuClicked = false;
                    this.isAdminMenuClicked = false;
                    this.isProfileMenuClicked = false;
                    break;
                case MENU_CONSTANTS.HELP:
                    this.isInfoMenuClicked = !this.isInfoMenuClicked;
                    this.isAdminMenuClicked = false;
                    this.isProfileMenuClicked = false;
                    this.isSupportMenuClicked = false;
                    break;
                case MENU_CONSTANTS.SETTINGS:
                    this.isAdminMenuClicked = !this.isAdminMenuClicked;
                    this.isInfoMenuClicked = false;
                    this.isProfileMenuClicked = false;
                    this.isSupportMenuClicked = false;
                    break;
                case MENU_CONSTANTS.USERMENU:
                    this.isProfileMenuClicked = !this.isProfileMenuClicked;
                    this.isInfoMenuClicked = false;
                    this.isAdminMenuClicked = false;
                    this.isSupportMenuClicked = false;
            }
        }
    }

    closeSubmenu(): void {
        this.isInfoMenuClicked = false;
        this.isAdminMenuClicked = false;
        this.isProfileMenuClicked = false;
        this.isSupportMenuClicked = false;
    }
}
